import React, { Component } from 'react'
import './setup-section.scss'

import SchoolApi from '../../../apis/school'
import Dropdown from '../../common/dropdown-v2/dropdown'
import { ImageConstants, Constants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import AddNewTeacher from '../../teachers/add-new-contact/add-new-contact'
import { Modal, ModalBody } from 'reactstrap'
import SessionCache from '../../routes/session-cache'

class SetupClass extends Component {
  state = {
    class: [],
    board: [],
    selectedNoSection: false,
    sections: [
      {
        sectionName: 'A'
      }
      // {
      //   sectionName: 'B'
      // },
      // {
      //   sectionName: 'C'
      // },
      // {
      //   sectionName: 'D'
      // },
      // {
      //   sectionName: 'E'
      // }
    ],
    numberOfSections: 0,
    allowSectionNameEdit: []
  }
  selectedClass = {}

  sectionsCount = Constants.SECTION_DROPDOWN

  componentDidMount() {
    this.getStaffs()
    this.getSectionsApi()
    if (this.props.from === 'teachers') {
      const sections = this.state.sections
      sections.splice(1, 5)
      this.setState({
        sections
      })
    }

    if (this.props.hideSectionName) {
      this.onChangeTableValue("No Sections", 0, 'sectionName')
    }
  }

  getStaffs(payload = {}) {
    payload.types = `in/MATH_TEACHER,MATH_HOD`
    SchoolApi.getStaffs(payload)
      .then(staffs => {
        let mathTeachers = [],
          mathTeachersHash = {}
        for (let i = 0; i < staffs?.response?.length; i++) {
          let staff = staffs?.response[i]

          for (let j = 0; j < staff?.types?.length; j++) {
            if (!mathTeachersHash[staff._id]) {
              mathTeachersHash[staff._id] = true
              mathTeachers.push({
                title: staff.firstName,
                value: staff._id
              })
            }
          }
        }
        this.setState(
          { mathTeacherDropdown: mathTeachers, reloadDropdown: true },
          () => {
            this.setState({ reloadDropdown: false })
          }
        )
      })
      .catch(err => { })
  }

  getSectionsApi() {
    let payload = {
      class: this.props.class
    }
    if (this.props.board) payload.board = this.props.board

    SchoolApi.getSections(payload)
      .then(response => {

        if (!response?.response?.length || (response?.response[0]?.noSectionInClass == true)) {



          this.setState({ deleteSectionId: response?.response[0]?._id })
          return
        }

        let sections = []
        console.log(response.response)
        for (let i = 0; i < response.response.length; i++) {
          let section = response.response[i]
          let obj = {
            id: section._id,
            sectionName: section.section,
            teacher: section.teacherId,
            strength: section.strength
          }
          sections.push(obj)
        }

        if (sections[0].sectionName !== 'No Sections') {
          sections.push({ sectionName: '', strength: 0 })
        }

        const { allowSectionNameEdit } = this.state
        allowSectionNameEdit[sections.length - 1] = true
        this.setState(
          { sections: sections, allowSectionNameEdit, reloadDropdown: true },
          () => {
            this.setState({ reloadDropdown: false })
          }
        )
      })
      .catch(err => {
        this.setState({ sections: [] })
      })
  }

  onSelectSectionNumber = option => {
    this.setState({ numberOfSections: option?.value })
  }

  onSelectClass = option => {
    this.selectedClass = this.state.class.filter(
      item => item.value == option
    )[0]
    this.setState(
      { selectedClass: option, numberOfSections: '', reload: true },
      () => {
        this.setState({ reload: false })
        this.getSectionsApi()
      }
    )
  }

  onSelectBoard = option => {
    this.setState(
      { selectedBoard: option, numberOfSections: '', reload: true },
      () => {
        this.setState({ reload: false })
        this.getSectionsApi()
      }
    )
  }

  onSectionChangeHandler = sections => {
    this.setState({ sections }, () => {
      let payload = {
        class: this.state.selectedClass,
        board: this.state.selectedBoard,
        sections: this.getSections(this.state.sections)
      }
      let validation = this.validatePayload(payload, true)
      this.setState({ validation })
    })
  }

  cleanPayload(payload) {
    const sections = []
    payload.sections.map(s => {
      if (this.props.from === 'teachers') {
        if (s.sectionName && s.strength) {
          sections.push(s)
        }
      } else {
        if (s.id || (s.sectionName && s.strength)) {
          sections.push(s)
        }
      }
    })
    payload.sections = sections
    return payload
  }

  onClickSave() {
    if (this.saving) return
    let payload = {
      class: this.props.class,
      board: this.props.board,
      sections: this.state.sections,
    }

    console.log(payload)

    if (this.state.sections[0].sectionName === 'No Sections') {
      payload.noSectionInClass = true
    }


    let validate = this.validatePayload(payload)
    if (!validate) return

    if (this.state.deleteSectionId) {
      this.onClickDelete()
    }
    payload = this.cleanPayload(payload)
    this.saving = true
    console.log('step 1', payload)

    SchoolApi.addSchoolsSection(payload)
      .then(res => {
        this.saving = false
        console.log(res.data, res.data?.sections)

        if (this.props.from !== "teachers" && res.data?.sections?.length > 0) {
          let user = SessionCache.getUser()
          user.schoolInfo.totalSections = res.data?.sections?.length
          SessionCache.setUser(user)
          this.setState({
            addedSections: res.data.sections,
            showAddedSections: true
          })
        } else {
          if (this.props.onClose) {
            this.props.onClose(true)
          }
        }
      })
      .catch(err => {
        this.saving = false
      })
  }

  onClickDelete = () => {
    // let { payload, validation } = this.preparePayload()
    // if (!validation) {
    //     this.setState({ isSubmit: true })
    //     return
    // }
    let obj = {
      _id: this.state.deleteSectionId,

    }

    SchoolApi.deleteSchoolSection(obj)
      .then(response => {
        // this.props.onOk && this.props.onOk()
      }).catch(err => {
        console.log(err)
      })

  }

  onOk = _ => {
    if (this.props.onClose) {
      this.props.onClose(true)
    }
  }

  validatePayload = (payload = {}, dontShowMessage) => {
    let sectionValidation = this.validateSectionPayload(
      payload.sections,
      dontShowMessage
    )
    if (!sectionValidation) {
      this.setState({ validation: false })
      return sectionValidation
    }

    this.setState({ errorMessage: '', validation: true })
    return true
  }

  validateSectionPayload(sections, dontShowMessage) {
    console.log(sections)
    let validation = true
    if (!sections || !sections.length) {
      if (!dontShowMessage)
        this.setState({
          errorMessage: `Please enter sections information`,
          validation: false
        })
      return validation
    }

    for (let i = 0; i < sections.length; i++) {
      let section = sections[i]

      if (
        this.props.from === 'teachers' &&
        (!section.sectionName || !section.strength)
      ) {
        validation = false
      }

      if (
        this.props.from !== 'teachers' &&
        section.sectionName &&
        (!section.strength )
      ) {
        console.log(
          this.props.from !== 'teachers',
          section.sectionName,
          section.strength,
          section.teacher?.length,
          dontShowMessage
        )
        if (!dontShowMessage)

          if (section.sectionName == 'No Sections') {
            this.setState({
              errorMessage: `Fill strength & teacher for the Class`
            }, _ => {
              console.log(this.state.errorMessage)
            })
            validation = false

          } else {
            this.setState({
              errorMessage: `Fill strength & teacher for section ${section.sectionName}`
            }, _ => {
              console.log(this.state.errorMessage)
            })
            validation = false
          }


      }

      //   if (
      //     this.props.from !== 'teachers' &&
      //     section.sectionName &&
      //     section.strength &&
      //     section.teacher?.length > 0
      //   ) {
      //     if (!dontShowMessage)
      //       this.setState({
      //         errorMessage: `Fill Section name, strength & teacher in atleast one row`
      //       })
      //     validation = true
      //   }
    }
    // if (!dontShowMessage) this.setState({ errorMessage: this.props.from === "teachers" ? `Fill Section name & strength in atleast one row` : `Fill Section name, strength & teacher in atleast one row` })
    console.log(validation)
    this.setState({ validation })
    return validation
  }

  onSelectMathTeacher(option, index, key) {
    let teachers = []
    if (option && option.length) {
      teachers = option.map(item => item.value)
    }
    let sections = this.state.sections
    console.log(sections)
    sections[index][key] = teachers
    this.setState({ sections }, () => {
      this.validateSectionPayload(this.state.sections, true)
    })
  }

  onChangeTableValue = (event, index, key) => {
    let sections = this.state.sections

    if (event == 'No Sections') {
      if (sections[0]?.sectionName == 'No Sections') {
        const index = sections.splice(0, 1)
        sections = [
          {
            sectionName: "A"
          }
        ]
      } else {
        
        sections[index][key] = event
        if (key === 'sectionName') {
          sections[index].updated = true
        }
      }

      this.setState({ sections, selectedNoSection: !this.state.selectedNoSection }, () => {
        this.validateSectionPayload(this.state.sections, true)
      })

    } else {
      sections[index][key] = event.target.value
      if (key === 'sectionName') {
        sections[index].updated = true
      }
      this.setState({ sections }, () => {
        this.validateSectionPayload(this.state.sections, true)
      })
    }
  }

  addNewTeacher = index => {
    this.setState({ showAddNewTeacher: true, addTeacherIndex: index })
  }

  hideNewTeacher = selectedTeacherId => {
    if (selectedTeacherId) {
      let teachers =
        this.state.sections[this.state.addTeacherIndex]?.teacher || []
      teachers.push(selectedTeacherId)
      let sections = this.state.sections
      sections[this.state.addTeacherIndex].teacher = teachers
      this.setState({ sections }, () => {
        this.validateSectionPayload(this.state.sections, true)
      })
    }
    this.setState({ showAddNewTeacher: false })
    this.getStaffs()
  }

  addOneMoreSection = () => {
    let sections = this.state.sections
    sections.push({ section: '', strength: 0 })
    const { allowSectionNameEdit } = this.state
    allowSectionNameEdit[sections.length - 1] = true
    this.setState({ sections, allowSectionNameEdit }, () => {
      this.validateSectionPayload(this.state.sections, true)
    })
  }

  onClickDelete(index) {
    let sections = this.state.sections
    if (sections.length == 1) {
      sections[0] = {
        sectionName: 'A'
      }
    } else {
      sections.splice(index, 1)
    }
    this.setState({ sections }, () => {
      this.validateSectionPayload(this.state.sections, true)
    })
  }

  renderAddNewContactModal() {
    return (
      <Modal
        className='cw-custom-modal'
        isOpen={true}
        toggle={this.hideNewTeacher}
        size={'lg'}
      >
        <ModalBody>
          <div className='row'>
            <div className='col text-right'>
              <img
                className='close-icon cursor-pointer'
                onClick={this.hideNewTeacher}
                src={getImageSource(ImageConstants.CROSS)}
              />
            </div>
          </div>
          <div className='header-text text-center'>
            <span>{'ADD NEW TEACHER'}</span>
          </div>
          <div className='px-4'>
            <AddNewTeacher
              hideDefaultType
              show={this.state.showAddNewTeacher}
              onClose={this.hideNewTeacher}
              size={'lg'}
            />
          </div>
        </ModalBody>
      </Modal>
    )
  }

  allowSectionNameEdit = idx => {
    let { allowSectionNameEdit } = this.state
    allowSectionNameEdit = allowSectionNameEdit.map(a => false)
    if (idx >= 0) allowSectionNameEdit[idx] = true
    this.setState({
      allowSectionNameEdit
    })
  }

  renderTables() {
    const { allowSectionNameEdit } = this.state
    return (
      <div className='mt-2'>
        <div id='table-scoll' className='table-responsive'>
          <table className='table section-table-1'>
            <thead>
              <tr className='text-center'>
                {/* {this.state.sections[0].sectionName == 'No Sections' ? '' : <th className='text-center'>Section </th>} */}
                {this.props.hideSectionName ? '' : <th className='text-center'>Section </th>}

                <th className='text-center'>Strength </th>
                {this.props.from !== 'teachers' && (
                  <th className='text-center th-right-radius'>Maths Teacher</th>
                )}
              </tr>
            </thead>
            <tbody className='bg-white'>
              {this.state.sections.map((item, index) => (
                <tr className='mt-4' key={index}>
                  {this.props.hideSectionName ? '' : <td className='text-center veritical-align section-name'>
                    {allowSectionNameEdit[index] ? (
                      <input
                        placeholder='Section'
                        value={item.sectionName}
                        onChange={event =>
                          this.onChangeTableValue(event, index, 'sectionName')
                        }
                      />
                    ) : (
                      <div
                        className='section-name-disabled cursor-pointer'
                        onClick={() => this.allowSectionNameEdit(index)}
                      >
                        <span>{item.sectionName}</span>
                        <img
                          className='custom-add-icon section-name-edit'
                          src={getImageSource(ImageConstants.PENCIL_ICON)}
                        />
                      </div>
                    )}
                  </td>}
                  <td className='veritical-align section-strength'>
                    <input
                      placeholder='Section Strength'
                      type='number'
                      min={0}
                      value={item.strength}
                      onChange={event =>
                        this.onChangeTableValue(event, index, 'strength')
                      }
                    />
                  </td>
                  {this.props.from !== 'teachers' && (
                    <td className='veritical-align'>
                      <div className='row'>
                        <div className='col-10 text-left pr-0'>
                          {!this.state.reloadDropdown ? (
                            <div className='dropdown-div'>
                              <Dropdown
                                placeholder='Select Teacher'
                                options={this.state?.mathTeacherDropdown}
                                onSelect={option =>
                                  this.onSelectMathTeacher(
                                    option,
                                    index,
                                    'teacher'
                                  )
                                }
                                text={'title'}
                                style={{ background: '#F6F7F5' }}
                                value={item.teacher || ''}
                                invalid={
                                  this.state.isSubmit && item?.teacher?.length
                                }
                                multiSelect
                              />
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                        <div className='col text-center my-auto pl-0'>
                          <img
                            className='custom-add-icon cursor-pointer'
                            onClick={() => this.addNewTeacher(index)}
                            src={getImageSource(ImageConstants.ADD)}
                          />
                        </div>
                      </div>
                    </td>
                  )}
                  {index != 0 && !item.id ? (
                    <td className='delete-icon veritical-align'>
                      <img
                        className='custom-add-icon cursor-pointer'
                        src={getImageSource(ImageConstants.DELETE_RED)}
                        onClick={() => this.onClickDelete(index)}
                      />
                    </td>
                  ) : (
                    ''
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  getTeacherName(teachers) {
    let name = teachers?.map(item => item.firstName)
    let len = name?.length
    if (name?.length > 2) {
      name.length = 2
      name = name.join(', ')
      return `${name} +${len - 2}`
    }
    return name?.join(', ')
  }

  render() {
    return (
      <div className='setup-section pb-5'>
        {this.state.showAddedSections ? (
          <>
            <div className='header-text text-center'>
              {this.state.sections[0]?.sectionName == 'No Sections' ? <span>Class Setup Done successfully</span> : <span>Sections added successfully</span>}
            </div>
            <div className='px-2 mt-5'>
              <table className='table section-table-1 added-sections'>
                <thead>
                  <tr>
                    {this.state.sections[0]?.sectionName == 'No Sections' ? "" : <th>
                      <strong>Section Name</strong>
                    </th>}

                    <th>
                      <strong>Strength</strong>
                    </th>
                    <th>
                      <strong>Math Teacher</strong>
                    </th>
                  </tr>
                </thead>
                <tbody className='bg-white'>
                  {this.state.addedSections?.length > 0 ? (
                    this.state.addedSections?.map((item, index) => (
                      <tr key={index} className='mt-4 tr-border border-bottom'>
                        {this.state.sections[0]?.sectionName == 'No Sections' ? "" : <td>{item?.section}</td>}

                        <td>{item?.strength}</td>
                        <td>{item?.teacher.length?this.getTeacherName(item?.teacher) : '--'}</td>
                      </tr>
                    ))
                  ) : (
                    <tr className='bg-white pt-4 border-bottom'>
                      <td colSpan='3' align='center'>
                        No Records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className='mt-4 text-center'>
              <div className={`cw-button-md`} onClick={() => this.onOk()}>
                OK
              </div>
            </div>
          </>
        ) : (
          <>
            <div className='header-text text-center'>
              <span>{this.props.title} SECTIONS FOR {this.props.class.toUpperCase()}</span>
            </div>

            {/* <div className='ml-2'> <img className="tick cursor-pointer" onClick={() => this.onChangeTableValue("No Sections", 0, 'sectionName')} src={getImageSource(this.state.sections[0]?.sectionName !== 'No Sections' ? ImageConstants.RECT_BLACK : ImageConstants.RECT_TICK)} />
              <span className='ml-1'>There are No Section in this Class</span></div> */}
            <div className='px-2'>{this.renderTables()}</div>
            {this.props.hideSectionName ? '' : <div className='footer-text'>
              <div className='note-text ml-2'>
                NOTE: Section could be renamed by you as per you school{' '}
              </div>
              <div className='section-add text-right mr-2'>
                <span
                  className='cursor-pointer'
                  onClick={this.addOneMoreSection}
                >
                  + ADD SECTION
                </span>
              </div>
            </div>}


            <div className='mt-4 text-center'>
              {this.state.errorMessage ? (
                <div className='text-danger pb-4'>
                  <strong>{this.state.errorMessage} </strong>
                </div>
              ) : (
                ''
              )}
              <div
                className={`cw-button-md ${!this.state.validation ? 'disable-button' : ''
                  }`}
                onClick={() => this.onClickSave()}
              >
                Save
              </div>
            </div>
          </>
        )}

        {this.state.showAddNewTeacher && this.props.modalType != 'RIGHT'
          ? this.renderAddNewContactModal()
          : ''}
      </div>
    )
  }
}

export default SetupClass
